import { useState } from "react";
import { Loader2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { business_name: "", name: "", email: "", phone: "", city: "", industry: "auto repair shop", website_url: "", notes: "", create_login: true };
const inp = "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm";

/* Call center: add a brand-new customer (lead + optional portal login). */
export const NewCustomerDialog = ({ open, onClose, prefill }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const onOpen = (o) => { if (!o) onClose(); };
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post("/api/callcenter/customers", f); toast.success(data.message); setF(EMPTY); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpen}>
      <DialogContent className="bg-white max-w-md" data-testid="new-customer-dialog" onOpenAutoFocus={() => prefill && setF({ ...EMPTY, ...prefill })}>
        <DialogHeader><DialogTitle>Add a new customer</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          <input className={`${inp} col-span-2`} placeholder="Business name *" value={f.business_name} onChange={set("business_name")} data-testid="nc-business" />
          <input className={inp} placeholder="Contact name" value={f.name} onChange={set("name")} data-testid="nc-name" />
          <input className={inp} placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="nc-phone" />
          <input className={`${inp} col-span-2`} type="email" placeholder="Email" value={f.email} onChange={set("email")} data-testid="nc-email" />
          <input className={inp} placeholder="City" value={f.city} onChange={set("city")} data-testid="nc-city" />
          <input className={inp} placeholder="Type (e.g. tire shop)" value={f.industry} onChange={set("industry")} data-testid="nc-industry" />
          <input className={`${inp} col-span-2`} placeholder="Website (optional)" value={f.website_url} onChange={set("website_url")} data-testid="nc-website" />
          <textarea className={`${inp} col-span-2`} rows={2} placeholder="Notes" value={f.notes} onChange={set("notes")} data-testid="nc-notes" />
        </div>
        <label className="flex items-center gap-2 text-sm text-slate-700"><input type="checkbox" checked={f.create_login} onChange={set("create_login")} data-testid="nc-login" />Create their portal login and email them a set-password link</label>
        <button onClick={save} disabled={!f.business_name.trim() || busy} className="w-full h-11 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold flex items-center justify-center gap-2 disabled:opacity-40" data-testid="nc-save-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />}Add customer</button>
      </DialogContent>
    </Dialog>
  );
};
